import {
  Component, ChangeDetectionStrategy,
} from '@angular/core'
import { LineClampComponent } from '@knorr-bremse-portals/ngx-components/components/line-clamp'

@Component({
  selector: 'figure[kb-figure]',
  templateUrl: './figure.component.html',
  styleUrls: ['./figure.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LineClampComponent],
})
export class FigureComponent {

}
